export default __webpack_public_path__ + "static/koala-def827237c0a90b449a1ad739fbdec5a0fa000f3cf56416f1c80168aa0aeb706.png";